module.exports = __webpack_public_path__ + "images/iphone/list_header_bg.png";